import React from 'react'

// MUI Component
import Typography from '@mui/material/Typography'

const PlaceholderText = ({ children, fontSize = '15vw', maxWidth = '100%', sx, ...restProps }) => {
  return (
    <Typography
      sx={{
        fontSize: `max(${fontSize}, 60px)`,
        fontWeight: 700,
        ...sx,
        color: '#E1E1E1',
        textAlign: 'center',
        wordBreak: 'break-all',
        wordWrap: 'break-word',
        maxWidth: maxWidth,
        display: 'block',
      }}
      {...restProps}
    >
      {children}
    </Typography>
  )
}

export default PlaceholderText
